import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupBy',
    standalone: true,
})
export class GroupByPipe<T> implements PipeTransform
{
    transform(collection: T[], key: string): T[][] {
        // return collection group by key
        const groups = [];
        const seen = new Map();

        collection.forEach(item => {
            const groupKey = item[key];

            if (!seen.has(groupKey)) {
                const newGroup = [item];
                groups.push(newGroup);
                seen.set(groupKey, newGroup);
            } else {
                seen.get(groupKey).push(item);
            }
        });

        return groups;
    }
}
